const lbaSelect = angular.module('app.lbaSelect', []);

lbaSelect.controller('lbaSelectCtrl', require('./lbaSelectCtrl'));
lbaSelect.directive('lbaSelect', require('./lbaSelectDir'));

export default lbaSelect;



// WEBPACK FOOTER //
// ./src/components/lbaSelect/index.js